namespace SPA
{
	export namespace Realtor2
	{
		export namespace New
		{
			import TextInput = ui.Form.TextInput;

			export class Common extends Guide.GuideContent
			{

				private m_SubmitForm: ui.Form.Form;
				private m_OwnerForm: ui.Form.Form;
				private m_SellerForm: ui.Form.Form;
				private m_SellerInput: ui.Form.BasicInputField;
				private m_OwnerInput: ui.Form.BasicInputField;

				public constructor(
					private m_Company: Wollmilch.CompanyObject,
					private objectData: IAObject,
					private m_Obj: Realtor2.NewObject
				)
				{
					super();

					this.m_OwnerForm = new ui.Form.Form({
						action: 'post', submit: () => {
							return;
						}
					});
					this.m_SellerForm = new ui.Form.Form({
						action: 'post', submit: () => {
							return;
						}
					});

					this.m_SubmitForm = new ui.Form.Form(
						{
							action: '',
							method: 'POST',
							notSwitchable: true,
							submit: () => {
								return;
							}
						}
					);
					this.m_SellerInput = new ui.Form.NumberInput(null, {
						name: 'object.seller.id',
						required: true
					}, true);
					this.m_OwnerInput = new ui.Form.NumberInput(null, {
						name: 'object.owner.id',
						required: true
					}, true);
					this.m_SubmitForm.Input(this.m_SellerInput);
					this.m_SubmitForm.Input(this.m_OwnerInput);
				}

				public build( root: ui.base.BaseHTMLElement ): void
				{
					this.m_SubmitForm.empty();
					this.m_SubmitForm.remove();

					this.m_SubmitForm.rebuild( root );

					let fg = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
					.appendTo( this.m_SubmitForm );

					{ // # Anliegen / Vorhaben
						const otype = new ui.Form.HiddenTextInput('disposal', 'object.project');
						this.addToForm(this.m_SubmitForm, this.m_SubmitForm, otype);
					}

					fg = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
						.css(
							{
								'border-top': '1px',
								'border-color': 'RGB(230,230,230)',
								'border-style': 'solid'
							}
						)
					.appendTo( this.m_SubmitForm );

					{ // * Adresse
						const Adresse = new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-lg-9' )
						.appendTo( fg );

						new ui.base.BaseHTMLElement( 'label' )
							.addClass( 'control-label' )
							.text( 'Bitte geben Sie die den Standort des Objektes ein:' )
						.appendTo( Adresse );

						const adr_list = SPA.gui.form.SimpleStyledPostalAddress(
							this.m_SubmitForm,
							Adresse,
							'object.address',
							{},
							"hidden"
						);
					}

					fg = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'form-group clearfix' )
						.css(
							{
								'border-top': '1px',
								'border-color': 'RGB(230,230,230)',
								'border-style': 'solid'
							}
						)
					.appendTo( this.m_SubmitForm );

					{ // * Kunde
						this.buildSeller(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12 col-md-6 col-lg-6 c2' )
							.appendTo( fg )
						);
					}

					{ // * Eigentümer
						this.buildOwner(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'col-xs-12 col-md-6 col-lg-6 c2' )
							.appendTo( fg )
						);
					}
				}

				protected buildNavigation( nav: ui.base.BaseHTMLElement ): void
				{
					new ui.base.Button(
						'Abbrechen',
						{
							css: {
								opacity: '0.0',
								cursor: 'default'
							}
						}
					).rebuild( nav );

					new ui.base.Button(
						$('<span>Weiter</span> <i class="fas fa-arrow-circle-right"></i>'),
						{
							context: 'primary',
							on:
							{
								click: () =>
								{
									if ( this.m_Panel )
									{
										if ( this.m_Obj.checkForm( this.m_SubmitForm ) )
										{
											this.objectData.address.street = this.m_SubmitForm.get('object.address.street').val();
											this.objectData.address.housenumber = this.m_SubmitForm.get('object.address.housenumber').val();
											this.objectData.address.postalcode = this.m_SubmitForm.get('object.address.postalcode').val();
											this.objectData.address.city = this.m_SubmitForm.get('object.address.city').val();
											this.objectData.address.state = this.m_SubmitForm.get('object.address.state').val();
											this.objectData.address.ags = this.m_SubmitForm.get('object.address.ags').val();

											this.m_Panel.MoveNext();
										}
									}
								}
							}
						}
					).rebuild( nav );
				}

				private buildSeller( container: ui.base.BaseHTMLElement ): void
				{
					let row = new ui.base.BaseHTMLElement( 'div' ).addClass('form-group row');
					const fGroup = new ui.base.BaseHTMLElement('div').addClass( 'col-xs-12' )
						.appendTo( row );

					container.append($('<div class="row"><h3 style="margin-left: 15px;">Objekt-Verkäufer</h3></div>'));

					const btnCol = new ui.base.BaseHTMLElement( 'div' ).addClass('col-xs-12');

					const btnAddCustomer = new ui.base.Button(
						'',
						{
							context: 'primary',
							attr: {type: 'button'},
							on: {
								click: () => {
									const contactModal = new SPA.Contacts.Modal(this.m_Company);

									// Set modal title
									contactModal
										.setTitle('Neuen Objekt-Verkäufer anlegen')
										.setPrimaryButtonText('Anlegen')
										.setType('seller')
										.setCallback((contact: SPA.Contact) =>
										{
											this.m_SellerInput.value(contact.ContactID);
											this.objectData.seller.id = contact.ContactID;

											// Visuals
											(this.m_SellerForm.get('object.seller.salutation') as TextInput).value(contact.Salutation);
											(this.m_SellerForm.get('object.seller.surname') as TextInput).value(contact.Surname);
											(this.m_SellerForm.get('object.seller.name') as TextInput).value(contact.Name);
											(this.m_SellerForm.get('object.seller.title') as TextInput).value(contact.Title);

											// added _display on getter, because this is set if ContactForm is disabled
											// ToDo: Handle disabled Forms get selector automatically with _display
											(this.m_SellerForm.get('object.seller.street_display') as TextInput).value(contact.Street);
											(this.m_SellerForm.get('object.seller.housenumber_display') as TextInput).value(contact.HouseNumber);
											(this.m_SellerForm.get('object.seller.postalcode_display') as TextInput).value(contact.PostalCode);
											(this.m_SellerForm.get('object.seller.city_display') as TextInput).value(contact.City);
											(this.m_SellerForm.get('object.seller.state_display') as TextInput).value(contact.State);
										})
										// show the form
										.show();
								}
							}
						}
					).addClass('btn-sm').append($('<i class="fas fa-plus-circle"></i> <span>Neuer Verkäufer</span>'));
					btnAddCustomer.rebuild(btnCol);
					btnAddCustomer.appendTo(btnCol);
					btnCol.appendTo(row);
					row.appendTo(container);

					{ // # Kundensuche TypeAHead
						new ui.base.BaseHTMLElement( 'label' )
							.addClass( 'sr-only' )
							.text( 'Objekt-Verkäufer suchen' )
						.appendTo( fGroup );

						const search: ui.Form.InputTypeahead = new ui.Form.InputTypeahead(
							{
								placeholder: 'Kontakte nach Objekt-Verkäufer durchsuchen',
								displayText: (contact: Contact): string =>
								{
									return contact.getSalutationMapped()  + ' ' + contact.Surname + ", " + contact.Name + ' | ' + contact.completeAddress();
								},
								afterSelect: (contact: Contact) =>
								{
									this.m_SellerInput.value(contact.ContactID);
									this.objectData.seller.id = contact.ContactID;

									// Visuals
									(this.m_SellerForm.get('object.seller.salutation') as TextInput).value(contact.Salutation);
									(this.m_SellerForm.get('object.seller.surname') as TextInput).value(contact.Surname);
									(this.m_SellerForm.get('object.seller.name') as TextInput).value(contact.Name);
									(this.m_SellerForm.get('object.seller.title') as TextInput).value(contact.Title);
									(this.m_SellerForm.get('object.seller.street_display') as TextInput).value(contact.Street);
									(this.m_SellerForm.get('object.seller.housenumber_display') as TextInput).value(contact.HouseNumber);
									(this.m_SellerForm.get('object.seller.postalcode_display') as TextInput).value(contact.PostalCode);
									(this.m_SellerForm.get('object.seller.city_display') as TextInput).value(contact.City);
									(this.m_SellerForm.get('object.seller.state_display') as TextInput).value(contact.State);
								}
							}
						).rebuild( fGroup ) as ui.Form.InputTypeahead;
						search.Source(app.getContactManager().getContacts().models);
					}

					row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( container );

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-6')
							.append(
								new ui.base.BaseHTMLElement('label')
									.text('Anrede')
							)
							.appendTo(row),
						this.m_SellerForm,
						new ui.Form.Select(
							{
								blank: ' --- ',
								name: 'object.seller.salutation',
								disabled: true,
								control: true,
								required: true,
								option: SPA.types.Convert.ToObjectList(SPA.types.Salutation)
							},
							undefined
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-6')
							.append(
								new ui.base.BaseHTMLElement('label')
									.text('Titel')
							)
							.appendTo(row),
						this.m_SellerForm,
						new ui.Form.TextInput(
							null,
							{
								disabled: true,
								name: 'object.seller.title',
								control: true,
							}
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-sm-7')
							.append(
								new ui.base.BaseHTMLElement('label')
									.text('Nachname*')
							)
							.appendTo(row),
						this.m_SellerForm,
						new ui.Form.TextInput(
							null,
							{
								name: 'object.seller.surname',
								disabled: true,
								control: true,
								required: true
							}
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-sm-5')
							.append(
								new ui.base.BaseHTMLElement('label')
									.text('Vorname*')
							)
							.appendTo(row),
						this.m_SellerForm,
						new ui.Form.TextInput(
							null,
							{
								name: 'object.seller.name',
								disabled: true,
								control: true,
								required: true
							}
						)
					);

					row = new ui.base.BaseHTMLElement('div')
						.addClass('row')
						.appendTo(container);

					const adr_list = SPA.gui.form.SimpleStyledPostalAddress(
						this.m_SellerForm,
						row,
						'object.seller',
						{},
						"none",
						true
					);
				}

				private buildOwner( formgroup: ui.base.BaseHTMLElement ): void
				{
					// #region owner_title
					let row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( formgroup );

					new ui.base.BaseHTMLElement( 'h3' )
						.addClass( 'col-xs-12' )
						.text( 'Objekt-Eigentümer' )
						.appendTo( row );

					const btnAddOwner = new ui.base.Button(
						'',
						{
							context: 'primary',
							attr: {type: 'button'},
							on: {
								click: () => {
									const contactModal = new SPA.Contacts.Modal(this.m_Company);

									// Set modal title
									contactModal
										.setTitle('Neuen Objekt-Eigentümer anlegen')
										.setPrimaryButtonText('Anlegen')
										// Build and append the new "customer" form
										.setType('owner')
										// Set data for later sync
										.setCallback((contact: SPA.Contact) =>
										{
											this.m_OwnerInput.value(contact.ContactID);
											this.objectData.owner.id = contact.ContactID;

											// Visuals
											(this.m_OwnerForm.get('object.owner.salutation') as TextInput).value(contact.Salutation);
											(this.m_OwnerForm.get('object.owner.surname') as TextInput).value(contact.Surname);
											(this.m_OwnerForm.get('object.owner.name') as TextInput).value(contact.Name);
											(this.m_OwnerForm.get('object.owner.title') as TextInput).value(contact.Title);
											(this.m_OwnerForm.get('object.owner.street_display') as TextInput).value(contact.Street);
											(this.m_OwnerForm.get('object.owner.housenumber_display') as TextInput).value(contact.HouseNumber);
											(this.m_OwnerForm.get('object.owner.postalcode_display') as TextInput).value(contact.PostalCode);
											(this.m_OwnerForm.get('object.owner.city_display') as TextInput).value(contact.City);
											(this.m_OwnerForm.get('object.owner.state_display') as TextInput).value(contact.State);
										})
										// show the form
										.show();
								}
							}
						}
					).addClass('btn-sm').append($('<i class="fas fa-plus-circle"></i> <span>Neuer Eigentümer</span>'));
					btnAddOwner.Initialize();

					const btnCopyFromSeller = new ui.base.Button(
						'',
						{
							context: 'default',
							on:
							{
								click: () =>
								{
									this.m_OwnerInput.value(this.m_SellerInput.val());
									this.objectData.owner.id = this.m_OwnerInput.val();

									// Visuals
									const contact = app.getContactManager().getItem(this.m_OwnerInput.val());
									if (!contact)
									{
										alert('Der gesuchte Kontakt wurde nicht gefunden');
										return;
									}

									(this.m_OwnerForm.get('object.owner.salutation') as TextInput).value(contact.Salutation);
									(this.m_OwnerForm.get('object.owner.surname') as TextInput).value(contact.Surname);
									(this.m_OwnerForm.get('object.owner.name') as TextInput).value(contact.Name);
									(this.m_OwnerForm.get('object.owner.title') as TextInput).value(contact.Title);
									(this.m_OwnerForm.get('object.owner.street_display') as TextInput).value(contact.Street);
									(this.m_OwnerForm.get('object.owner.housenumber_display') as TextInput).value(contact.HouseNumber);
									(this.m_OwnerForm.get('object.owner.postalcode_display') as TextInput).value(contact.PostalCode);
									(this.m_OwnerForm.get('object.owner.city_display') as TextInput).value(contact.City);
									(this.m_OwnerForm.get('object.owner.state_display') as TextInput).value(contact.State);
								}
							},
							attr:
							{
								type: 'button'
							}
						}
					).addClass('btn-sm').append($('<i class="fas fa-arrow-circle-down"></i> <span>Verkäuferdaten übernehmen</span>'));
					btnCopyFromSeller.Initialize();

					const search: ui.Form.InputTypeahead = new ui.Form.InputTypeahead(
						{
							placeholder: 'Kontakte nach Objekt-Eigentümer durchsuchen',
							displayText: (contact: Contact): string => {
								return contact.getSalutationMapped() + ' ' + contact.Surname + ", " + contact.Name + ' | ' + contact.completeAddress();
							},
							afterSelect: (contact: Contact) => {
								this.m_OwnerInput.value(contact.ContactID);
								this.objectData.owner.id = contact.ContactID;

								// Visuals
								(this.m_OwnerForm.get('object.owner.salutation') as TextInput).value(contact.Salutation);
								(this.m_OwnerForm.get('object.owner.surname') as TextInput).value(contact.Surname);
								(this.m_OwnerForm.get('object.owner.name') as TextInput).value(contact.Name);
								(this.m_OwnerForm.get('object.owner.title') as TextInput).value(contact.Title);
								(this.m_OwnerForm.get('object.owner.street_display') as TextInput).value(contact.Street);
								(this.m_OwnerForm.get('object.owner.housenumber_display') as TextInput).value(contact.HouseNumber);
								(this.m_OwnerForm.get('object.owner.postalcode_display') as TextInput).value(contact.PostalCode);
								(this.m_OwnerForm.get('object.owner.city_display') as TextInput).value(contact.City);
								(this.m_OwnerForm.get('object.owner.state_display') as TextInput).value(contact.State);
							}
						}
					);
					search.Initialize();
					search.Source(app.getContactManager().getContacts().models);

					const rowSearch = new ui.base.BaseHTMLElement( 'div' ).addClass( 'row form-group' )
						.append(ui.$$.div().addClass('col-xs-12')
							.append(search.Input())
						)
						.append(ui.$$.div().addClass('col-xs-12')
							.append(btnAddOwner.Root())
							.append(btnCopyFromSeller.Root())
						);
					rowSearch.appendTo(formgroup);

					// #region row1
					row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( formgroup );

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-6' )
							.append(
								new ui.base.BaseHTMLElement( 'label' )
								.text( 'Anrede' )
							)
						.appendTo( row ),
						this.m_OwnerForm,
						new ui.Form.Select(
							{
								blank: ' --- ',
								name: 'object.owner.salutation',
								disabled: true,
								control: true,
								required: true,
								option: SPA.types.Convert.ToObjectList(SPA.types.Salutation)
							},
							undefined
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass( 'col-xs-6' )
							.append(
								new ui.base.BaseHTMLElement('label')
									.text('Titel')
							)
							.appendTo(row),
						this.m_OwnerForm,
						new ui.Form.TextInput(
							null,
							{
								disabled: true,
								name: 'object.owner.title',
								control: true,
							}
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement('div')
							.addClass('col-xs-12 col-sm-7')
							.append(
								new ui.base.BaseHTMLElement('label')
									.text('Nachname*')
							)
							.appendTo(row),
						this.m_OwnerForm,
						new ui.Form.TextInput(
							null,
							{
								name: 'object.owner.surname',
								disabled: true,
								control: true,
								required: true
							}
						)
					);

					this.addToForm(
						new ui.base.BaseHTMLElement( 'div' )
							.addClass( 'col-xs-12 col-sm-5' )
							.append(
								new ui.base.BaseHTMLElement( 'label' )
								.text( 'Vorname*' )
							)
						.appendTo( row ),
						this.m_OwnerForm,
						new ui.Form.TextInput(
							null,
							{
								name: 'object.owner.name',
								disabled: true,
								control: true,
								required: true
							}
						)
					);

					// #endregion row2

					// #region owner_address
					row = new ui.base.BaseHTMLElement( 'div' )
						.addClass( 'row' )
					.appendTo( formgroup );

					{
						// const Adresse = new ui.base.BaseHTMLElement( 'div' )
						// 	.addClass( 'col-xs-12' )
						// .appendTo( row );

						const adr_list = SPA.gui.form.SimpleStyledPostalAddress(
							this.m_OwnerForm,
							row,
							'object.owner',
							{},
							"none",
							true
						);
					}
					// #endregion owner_address
				}
			}
		}
	}
}
